<template>
  <v-container fluid class="ma-4 px-8">
    <v-row>
      <v-col cols="12" md="2" class="py-0 my-0">
        <v-autocomplete
          v-model="form.type"
          :items="feeTypes"
          outlined
          dense
          hide-details="auto"
          label="Particular"
          item-text="text"
          item-value="id"
          @change="reportData = { fee: [], current_date: null }"
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="2" class="py-0 my-0">
        <v-autocomplete
          v-model="form.year_batch"
          :items="batches"
          outlined
          dense
          hide-details="auto"
          label="Batch"
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" class="py-0 my-0">
        <v-btn class="accent white--text" @click="fetchReport()">
          Search
        </v-btn>
        <v-btn class="accent white--text ml-2" @click="download">
          <v-icon>mdi-download</v-icon> Download
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="reportData?.fee?.length">
      <v-col cols="12" class="text-center py-0 mt-3">
        <span class="text-5xl font-weight-bold accent--text">
          {{ form.type }} Payment Status as on {{ reportData.current_date }}
        </span>
      </v-col>
      <v-col cols="12" class="d-flex justify-center">
        <table border="1" cellpadding="15" cellspacing="0" class="text-center">
          <thead>
            <tr>
              <th class="px-2">Programme</th>
              <th v-for="key in programPartnerSummary" :key="key" class="px-2">
                {{
                  key != "received_percentage" ? formatKey(key) : "Received %"
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in reportData.fee"
              :key="index"
              :class="{
                'highlight-row': isTotalRow(item.program_name),
              }"
            >
              <th
                class="px-2"
                :class="{
                  'right-align-row': isTotalRow(item.program_name),
                }"
              >
                {{ item.program_name }}
              </th>
              <td
                v-for="key in programPartnerSummary"
                :key="key"
                style="min-width: 70px"
              >
                {{ item[key] ? formatValue(item[key]) : 0 }}
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
    <v-row v-if="!reportData?.fee?.length" align="center" class="px-4">
      <v-col cols="12" class="d-flex justify-center position-relative">
        <span class="text-h6"> No Data Found</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      form: {
        raised_batch: null,
        year_batch: null,
        type: null,
      },
      reportData: [],
      feeRaisedBatches: [],
      programPartnerSummary: [
        "excess_payment_count",
        "excess_payment_value",
        "refunded_count",
        "refunded_value",
        "adjusted_count",
        "adjusted_value",
        "received_percentage",
      ],
      feeTypes: [
        { id: "Exam Fee", text: "Exam Fee" },
        { id: "Term Fee", text: "Term Fee" },
        { id: "Annual", text: "Annual Fee" },
        { id: "Re-Admission Fee", text: "Re-Admission Fee" },
        { id: "Convocation Fee", text: "Convocation Fee" },
      ],
      batches: [],
    };
  },
  async created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Excess Report" }]);
    await this.generateExamBatchList();
    await this.generateBatchList();
    await this.fetchReport();
  },
  methods: {
    isTotalRow(code) {
      return code.includes("Total");
    },
    formatKey(key) {
      let newKey = key;
      let keyList = key.split("_");
      newKey = newKey
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());

      if (keyList.includes("amount") || keyList.includes("value"))
        return newKey + " (₹)";

      return newKey;
    },
    formatValue(value) {
      const num = parseFloat(value);
      if (!isNaN(num)) {
        return Math.round(num).toLocaleString("en-IN");
      }
      return value;
    },
    async fetchReport() {
      const queryString = this.objectToQueryParams({
        ...this.form,
      });
      await this.$axios
        .get(`/get_mis_excess_payment_report?${queryString}`)
        .then((res) => {
          this.reportData = res.data.data;
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    objectToQueryParams(obj) {
      if (obj.year_batch) {
        const [year, batch] = obj.year_batch.split("-");
        obj.year = year;
        obj.batch = batch;
        delete obj.year_batch;
      }

      return Object.keys(obj)
        .filter(
          (key) =>
            obj[key] !== undefined && obj[key] !== null && obj[key] !== "",
        )
        .map(
          (key) => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]),
        )
        .join("&");
    },
    async download() {
      const queryString = this.objectToQueryParams({
        ...this.form,
      });
      this.$axios
        .get(`/download_mis_excess_payment_report?${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "text/csv" }),
            url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Excess Payment Report.csv");
          document.body.appendChild(link);
          link.click();
        });
    },
    async generateExamBatchList() {
      try {
        const response = await this.$axios.get("/fee_raised_batches");
        this.feeRaisedBatches = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async generateBatchList() {
      try {
        const response = await this.$axios.get("/get_year_batch");
        this.batches = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.right-align-row {
  text-align: right;
}
.highlight-row {
  background-color: #f2f2f2 !important;
  font-weight: bold;
}
</style>
